module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/dig-in-photo-c39d6f4fe8f59de1cad6bcc4160b669a.jpeg";